import { Component, ElementRef, Input } from '@angular/core';
import { Day } from './day';

@Component({
  selector: '[calendar-day]',
  templateUrl: './calendar-day.html',
  styleUrls: ['./calendar-day.scss'],
})

/**
 * 달력 날짜 컴포넌트
 */
export class CalendarDay {

  /**
   * 날짜 정보
   */
  public day: Day;

  constructor(public el: ElementRef) {}

  /**
   * 날짜 설정
   */
  @Input('day') set updateDay(day: Day) {
    this.day = day;
  }
}
